export const transformResponseGetShippingAvailabilityCriterion = criterion => ({
  id: criterion.id,
  internal_id: criterion.internal_id,
  name: criterion.name,
  description: criterion.description,
  conditions: criterion.conditions,
  shipping_method_ids: criterion.shipping_method_ids,
})

export const transformRequestCreateShippingAvailabilityCriterion = ({ storeId, criterion }) => ({
  storeId,
  criterion: {
    name: criterion.name,
    description: criterion.description,
    conditions: criterion.conditions,
  },
})

export const transformRequestEditShippingAvailabilityCriterion = ({ storeId, criterionId, criterion }) => ({
  storeId,
  criterionId,
  criterion: {
    name: criterion.name,
    description: criterion.description,
    conditions: criterion.conditions,
  },
})
